import { useState, useMemo } from 'react';

/**
 * useFilter - reusable filter + search hook
 * @param {Array} items    - full list of items
 * @param {string} searchKey - the key to search on (e.g. 'title')
 * @param {string} categoryKey - the key to filter by (e.g. 'category')
 * @returns { filtered, search, setSearch, category, setCategory, categories }
 */
export function useFilter(items = [], searchKey = 'title', categoryKey = 'category') {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');

  const categories = useMemo(() => {
    const unique = [...new Set(items.map(i => i[categoryKey]))];
    return ['All', ...unique];
  }, [items, categoryKey]);

  const filtered = useMemo(() => {
    return items.filter(item => {
      const matchCat = category === 'All' || item[categoryKey] === category;
      const matchSearch =
        !search ||
        item[searchKey]?.toLowerCase().includes(search.toLowerCase()) ||
        item.tags?.some(t => t.toLowerCase().includes(search.toLowerCase()));
      return matchCat && matchSearch;
    });
  }, [items, search, category, searchKey, categoryKey]);

  return { filtered, search, setSearch, category, setCategory, categories };
}
